import { Observable } from 'rxjs'
import { ProductReference } from '@spartacus/core'

export abstract class MbFeaturedProductAdapter {

  abstract load(): Observable<ProductReference[]>
}
